import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

export function TextInput({ icon: Icon, label, error, type = 'text', testId, suffix, className = '', ...props }) {
    return (
        <div className={`w-full ${className}`}>
            {label && <label className="block text-sm font-semibold text-gray-800 mb-1.5">{label}</label>}
            <div className="relative">
                {Icon && <Icon className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />}
                <input
                    type={type}
                    data-testid={testId}
                    className={`w-full h-14 bg-white border border-gray-200 rounded-2xl ${Icon ? 'pl-12' : 'pl-4'} ${suffix ? 'pr-12' : 'pr-4'} text-base text-gray-900 placeholder:text-gray-400 focus:border-brand focus:ring-2 focus:ring-brand/20 transition-all`}
                    {...props}
                />
                {suffix && <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5">{suffix}</div>}
            </div>
            {error && <p className="mt-1.5 text-sm text-red-500" data-testid={testId ? `${testId}-error` : undefined}>{error}</p>}
        </div>
    );
}

export function PasswordInput({ icon, label, error, testId, ...props }) {
    const [show, setShow] = useState(false);
    return (
        <TextInput
            type={show ? 'text' : 'password'}
            icon={icon}
            label={label}
            error={error}
            testId={testId}
            suffix={
                <button type="button" onClick={() => setShow((s) => !s)} className="text-gray-400 hover:text-gray-600" data-testid={testId ? `${testId}-toggle` : undefined}>
                    {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
            }
            {...props}
        />
    );
}
